import './Footer.css';
import footLogo from "../images/fusco_logo_footer.png";


function Footer() {
    return (
    <footer className="site-footer">
        <div className="footer-inner">
            <div className="footer-logo"><img src={footLogo} alt="Fusco's Detailing Logo" className="logo-img" /></div>
            <div className="footer-copy">All Rights Reserved | Fusco's Detailing © 2025</div>
        </div>
    </footer>
    )
}

export default Footer